import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'; // Import toast
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import { editMissionVisionApi } from 'Services/allApi';
import { MissionVisionApi } from 'Services/allApi';

const MissionVision = () => {
   const [formData, setFormData] = useState({
    mission_head: '',
    mission_description: '',
    vision_head: '',
    vision_description: '',
    });
  
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    // Fetch data on component mount
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await MissionVisionApi();
          console.log("response", response);
          const data = response.data;
          if (response.error) {
            setError(response.message);
          } else {
            setFormData({
                mission_head: data.mission_head || '',
                mission_description: data.mission_description || '',
                vision_head: data.vision_head || '',
                vision_description: data.vision_description || '',
            });
          }
        } catch (err) {
          setError('Failed to fetch data. Please try again.');
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }, []);
  
    // Handle form input changes
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };
  
  
    // Handle the update button
    const handleUpdate = async () => {

        try {
          const response = await editMissionVisionApi(2, formData); 
          if (response.error) {
            toast.error("Failed to update. Please try again.");
          } else {
            toast.success("MissionVision content updated successfully!");
          }
        } catch (error) {
          toast.error("Error updating home page bottom content.");
      }
    };
  
    if (loading) {
      return <div>Loading...</div>;
    }
  
    if (error) {
      return <div>Error: {error}</div>;
    }
  
    return (
      <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
        <h2 className="text-center text-3xl font-bold mb-5 mt-2">Mission and Vision</h2>
        <hr className="mb-4" />
  
        <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
          {/* mission_head */}
          <div className="sm:col-span-2">
            <label htmlFor="mission_head" className="block font-medium text-gray-900">Mission Head</label>
            <div className="mt-2">
              <input
                type="text"
                name="mission_head"
                id="mission_head"
                value={formData.mission_head}
                onChange={handleInputChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
              />
            </div>
          </div>
  
        
  
          {/* mission_description */}
          <div className="sm:col-span-4">
            <label htmlFor="mission_description" className="block font-medium text-gray-900">Mission Description</label>
            <div className="mt-2">
              <textarea
                name="mission_description"
                id="mission_description"
                value={formData.mission_description}
                onChange={handleInputChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
              />
            </div>
          </div>
  
          {/*vision_head */}
          <div className="sm:col-span-2">
            <label htmlFor="vision_head" className="block font-medium text-gray-900">Vision Head</label>
            <div className="mt-2">
              <input
                type="text"
                name="vision_head"
                id="vision_head"
                value={formData.vision_head}
                onChange={handleInputChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
              />
            </div>
          </div>
  
          {/* Button Link */}
          <div className="sm:col-span-2">
            <label htmlFor="vision_description" className="block font-medium text-gray-900">Vision Description</label>
            <div className="mt-2">
              <input
                type="text"
                name="vision_description"
                id="vision_description"
                value={formData.vision_description}
                onChange={handleInputChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
              />
            </div>
          </div>
          
        </div>
        <hr className="mt-5 mb-5" />
  
        {/* Update Button */}
        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleUpdate}
            className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            Update
          </button>
        </div>
      </div>
    );
  }
export default MissionVision